import script from "./ActionRequired.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionRequired.vue?vue&type=script&setup=true&lang=js"

import "./ActionRequired.vue?vue&type=style&index=0&id=d3e56228&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3e56228"]])

export default __exports__